import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

export const disbursementLedgerDownloadRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/disbursement-ledger-download/$id',
  component: lazyRouteComponent(
    () => import('@/pages/disbursement-ledger-download/disbursement-ledger-download-page'),
  ),
});
